module.exports = __webpack_public_path__ + "media/svg-new/svg-scale-eae5639d.svg";